var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    overflow: "visible"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M48 0C21.5 0 0 21.5 0 48s21.5 48 48 48 48-21.5 48-48S74.5 0 48 0zm0 89C25.4 89 7 70.6 7 48S25.4 7 48 7s41 18.4 41 41-18.4 41-41 41z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#17BED0",
    d: "M63.2 2.4L60.9 9c14.7 4.8 25.7 17.7 27.8 33.4h7.1c-2.2-18.7-15.2-34.2-32.6-40z"
  })));
}
export default SvgLoadingBlue;